
<dx-tab-panel [dataSource]="jobs" [selectedIndex]="0">
  <div *dxTemplate="let company of 'ftpImportJobsTemplate'">
    <ftpImport></ftpImport>
  </div>
  <div *dxTemplate="let company of 'ftpHeinzeImportJobsTemplate'">
    <ftpHeinzeImport></ftpHeinzeImport>
  </div>
  <div *dxTemplate="let company of 'ftpExportJobsTemplate'">
    <ftpExport></ftpExport>
  </div>
  <div *dxTemplate="let company of 'FtpSupplierPidMappingsImportJobsTemplate'">
    <FtpSupplierPidMappingsImport></FtpSupplierPidMappingsImport>
  </div>
  <div *dxTemplate="let company of 'FtpDataSourceImportJobsTemplate'">
    <FtpDataSourceImport></FtpDataSourceImport>
  </div>
  <div *dxTemplate="let company of 'urlImport'">
    <urlimport />
  </div>
  <div *dxTemplate="let company of 'mediaFtpExportJobsTemplate'">
    <mediaFtpExport></mediaFtpExport>
  </div>
  <div *dxTemplate="let company of 'fotoWareImportJobsTemplate'">
    <fotoWareImport></fotoWareImport>
  </div>

</dx-tab-panel>

